import { ChannelsConstants } from "../agent-channels/channels-constants";
import { CantileverState } from "./availability-models";

export class Modality {
  constructor(private modality: string) {}

  public getValue() {
    return this.modality;
  }
}

export class CantileverPresenceState {
  private constructor(private state: string) {}

  public getValue() {
    return this.state;
  }

  static AVAILABLE = new CantileverPresenceState("Available");
  static NOTAVAILABLE = new CantileverPresenceState("NotAvailable");
}

export class AvailabilityEvent {
  private constructor(private name: string) {}

  public getValue() {
    return this.name;
  }

  static INFO_CHAT_PRESENCE_CHANGED = new AvailabilityEvent("ChatPresenceChanged");
  static INFO_WEBFORM_PRESENCE_CHANGED = new AvailabilityEvent("WebformPresenceChanged");
  static INFO_GET_AVAILABILITY_EMPTY = new AvailabilityEvent("getAvailabilityEmpty");
  static INFO_INITIALIZATION_INPROGRESS = new AvailabilityEvent("InitializationInProgress");
  static INFO_INITIALIZATION_COMPLETE = new AvailabilityEvent("InitializationComplete");

  static WARN_PRESENCE_UPDATE_PENDING_INIT_INPROGRESS = new AvailabilityEvent("PresenceUpdatePendingInitInProgress");
  static ERR_PRESENCE_UPDATE_FAILED = new AvailabilityEvent("PresenceUpdateFailed");
  static ERR_INITIALIZATION_FAILED = new AvailabilityEvent("InitializationFailed");
  static ERR_INITIALIZATION_COMPLETE = new AvailabilityEvent("InitializationComplete");

  /** Event from agent-sdk */
  static INFO_AVAILABILITY_UPDATED = new AvailabilityEvent("availabilityUpdated");
  static INFO_UNREACHABLE_SERVICE = new AvailabilityEvent("unreachableByService");
  static INFO_GET_AVAILABILITY_FAILED = new AvailabilityEvent("getAvailabilityFailed");
  static INFO_GET_AVAILABILITY_RESTORED = new AvailabilityEvent("getAvailabilityRestored");
}

export class CantileverStateConstants {
  // @ngInject
  constructor(private channelsConstants: ChannelsConstants) {}

  readonly AVAILABLE: CantileverState = new CantileverState(
    CantileverPresenceState.AVAILABLE,
    this.channelsConstants.availabilityReason.Available
  );

  readonly NOTAVAILABLE: CantileverState = new CantileverState(
    CantileverPresenceState.NOTAVAILABLE,
    this.channelsConstants.availabilityReason.NotAvailable
  );

  readonly BUSY: CantileverState = new CantileverState(
    CantileverPresenceState.NOTAVAILABLE,
    this.channelsConstants.availabilityReason.Busy
  );

  readonly AWAY: CantileverState = new CantileverState(
    CantileverPresenceState.NOTAVAILABLE,
    this.channelsConstants.availabilityReason.Away
  );

  readonly MEETING: CantileverState = new CantileverState(
    CantileverPresenceState.NOTAVAILABLE,
    this.channelsConstants.availabilityReason.Meeting_Coaching
  );

  readonly TRAINING: CantileverState = new CantileverState(
    CantileverPresenceState.NOTAVAILABLE,
    this.channelsConstants.availabilityReason.BillableTraining
  );

  readonly LUNCH: CantileverState = new CantileverState(
    CantileverPresenceState.NOTAVAILABLE,
    this.channelsConstants.availabilityReason.Lunch
  );

  readonly BREAK: CantileverState = new CantileverState(
    CantileverPresenceState.NOTAVAILABLE,
    this.channelsConstants.availabilityReason.Break
  );

  readonly UNKNOWN: CantileverState = new CantileverState(
    CantileverPresenceState.NOTAVAILABLE,
    this.channelsConstants.availabilityReason.Unknown
  );

  readonly LOGOUT: CantileverState = new CantileverState(
    CantileverPresenceState.NOTAVAILABLE,
    this.channelsConstants.availabilityReason.LogOut
  );
}

export class ModalityConstants {
  public readonly WEBFORM: Modality;
  public readonly CHAT: Modality;
  // @ngInject
  constructor(private channelsConstants: ChannelsConstants) {
    this.WEBFORM = new Modality(this.channelsConstants.webFormModality);
    this.CHAT = new Modality(this.channelsConstants.chatModality);
  }
}
